import { useMemo } from 'react';
import type { PresetRange } from '../utils/presetRange';

interface Props {
  preset: PresetRange;
  dateFrom: string;
  dateTo: string;
  onPresetChange: (preset: PresetRange) => void;
  onCustomChange: (from: string, to: string) => void;
}

export default function DateRangeFilter({
  preset,
  dateFrom,
  dateTo,
  onPresetChange,
  onCustomChange,
}: Props) {
  const presets = useMemo(
    () => [
      { key: '7d' as PresetRange, label: '近 7 天' },
      { key: '30d' as PresetRange, label: '近 30 天' },
      { key: '90d' as PresetRange, label: '近 90 天' },
      { key: '1y' as PresetRange, label: '近 1 年' },
      { key: 'all' as PresetRange, label: '全部' },
    ],
    []
  );

  return (
    <div className="bg-white border border-gray-100 rounded-xl px-4 py-3 flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-1.5 text-xs text-gray-500 mr-1">
        <i className="ri-calendar-line" />
        时间范围
      </div>
      <div className="flex items-center bg-gray-50 rounded-lg p-0.5 flex-wrap gap-0.5">
        {presets.map(p => (
          <button
            key={p.key}
            onClick={() => onPresetChange(p.key)}
            className={`px-2.5 py-1 rounded-md text-xs font-medium cursor-pointer transition-all whitespace-nowrap ${
              preset === p.key
                ? 'bg-white text-teal-600 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {p.label}
          </button>
        ))}
        <button
          onClick={() => onPresetChange('custom')}
          className={`px-2.5 py-1 rounded-md text-xs font-medium cursor-pointer transition-all whitespace-nowrap ${
            preset === 'custom'
              ? 'bg-white text-teal-600 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          自定义
        </button>
      </div>

      {preset === 'custom' && (
        <div className="flex items-center gap-1.5 text-xs">
          <input
            type="date"
            value={dateFrom}
            max={dateTo || undefined}
            onChange={e => onCustomChange(e.target.value, dateTo)}
            className="px-2 py-1 border border-gray-200 rounded-md focus:outline-none focus:border-teal-400"
          />
          <span className="text-gray-400">至</span>
          <input
            type="date"
            value={dateTo}
            min={dateFrom || undefined}
            onChange={e => onCustomChange(dateFrom, e.target.value)}
            className="px-2 py-1 border border-gray-200 rounded-md focus:outline-none focus:border-teal-400"
          />
        </div>
      )}

      {preset !== 'custom' && preset !== 'all' && (
        <span className="text-xs text-gray-400 ml-auto">
          {dateFrom} ~ {dateTo}
        </span>
      )}
    </div>
  );
}
